import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "rounded": [{ rounded: ["squircle"] }],
      "shadow": [{ shadow: ["glass", "glass-highlight", "glow", "glow-lg", "float", "inset"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
